// Pressefotos-Galerie-Reihen.
// Die Karte öffnet (über kpn-modal) ein Vollbild-Popup mit der Bilder-Übersicht
// (Raster) – wie auf der Mediathek-Seite. Hier kümmern wir uns nur darum, dass
// ein Klick auf ein Bild im Raster die Einzelansicht (Lightbox) mit Durchblättern
// öffnet. Das Karussell läuft über das geteilte [data-carousel]-Markup.
// Bilder, deren Datei fehlt, blenden sich aus: darunter liegt per CSS bereits
// das gestreifte Hausmuster (siehe _pressefotos-reihen.scss). Ohne das hier
// zeigte der Browser sein kaputtes Bild-Symbol samt nacktem alt-Text
// (Rueckmeldung 22.09.2026). Der alt-Text bleibt fuer Screenreader erhalten,
// weil nur visuell ausgeblendet wird.
function hideBrokenImages(scope) {
  scope.querySelectorAll('img').forEach((img) => {
    // data-pf-broken statt visibility/display: das <img> behaelt seinen Platz
    // und wird nur transparent, sodass das gestreifte Muster des Containers
    // durchscheint (siehe _pressefotos-reihen.scss).
    const hide = () => img.setAttribute('data-pf-broken', '');
    // Wieder einblenden, falls ein Bild spaeter doch noch laedt (lazy loading
    // startet erst beim Scrollen, und das Karussell schiebt Karten in den
    // Viewport nach).
    img.addEventListener('load', () => img.removeAttribute('data-pf-broken'));
    img.addEventListener('error', hide);

    // Fehlt die Originaldatei, kann Craft keine Transform-URL bilden und liefert
    // src="" — ein leeres src loest KEIN error-Event aus, der Listener oben
    // greift dort also nie (Fehler vom 22.09.2026).
    if (!img.getAttribute('src') && !img.getAttribute('data-src')) {
      hide();
      return;
    }

    // NUR bereits abgeschlossene Ladevorgaenge hier pruefen. Ein noch nicht
    // gestartetes lazy-Bild hat complete === false und darf nicht ausgeblendet
    // werden — sonst verschwinden auch vorhandene Bilder.
    if (img.complete && img.naturalWidth === 0 && img.currentSrc) {
      hide();
    }
  });
}

export default function initPressefotosReihen() {
  const galleries = document.querySelectorAll('[data-pf-gallery]');
  const roots = document.querySelectorAll('[data-pf-root]');
  roots.forEach(hideBrokenImages);
  if (!galleries.length) return;

  galleries.forEach((gallery) => {
    // Das Popup (kpn-modal-body) nach <body> verschieben: der umgebende
    // content-blocks-Block hat [data-reveal] mit transform, was sonst zum
    // Bezugsrahmen für position:fixed würde – das Modal würde dann nicht
    // im Vollbild, sondern im Seitenfluss erscheinen. Trigger und Modal sind
    // über die modalid (Window-Events) entkoppelt, daher ist das gefahrlos.
    const modal = gallery.closest('kpn-modal-body');
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    // Die Popup-Bilder liegen ausserhalb von [data-pf-root], deshalb hier noch
    // einmal fuer das Raster im Modal.
    hideBrokenImages(gallery);
    initGallery(gallery);
  });
}

function initGallery(root) {
  const dialog = root.querySelector('[data-pf-dialog]');
  const imgContainer = root.querySelector('[data-pf-img]');
  const dataEl = root.querySelector('[data-pf-images]');
  const btnClose = root.querySelector('[data-pf-close]');
  const btnPrev = root.querySelector('[data-pf-prev]');
  const btnNext = root.querySelector('[data-pf-next]');
  const btnDownload = root.querySelector('[data-pf-download]');

  if (!dialog || !imgContainer || !dataEl) return;

  let images = [];
  let current = 0;

  try {
    images = JSON.parse(dataEl.textContent);
  } catch {
    return;
  }
  if (!images.length) return;

  function showImage(index) {
    current = (index + images.length) % images.length;
    const img = images[current];
    imgContainer.innerHTML = `<img src="${img.src}" srcset="${img.srcset}" sizes="(min-width: 1024px) 80vw, 100vw" alt="${img.alt}" loading="eager" />`;
    const multiple = images.length > 1;
    if (btnPrev) btnPrev.hidden = !multiple;
    if (btnNext) btnNext.hidden = !multiple;
    if (btnDownload) btnDownload.href = img.src;
  }

  // Bild im Raster anklicken -> Einzelansicht öffnen
  root.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-pf-open]');
    if (!thumb) return;
    showImage(parseInt(thumb.dataset.pfOpen, 10));
    dialog.showModal();
  });

  if (btnClose) btnClose.addEventListener('click', () => dialog.close());
  if (btnPrev) btnPrev.addEventListener('click', () => showImage(current - 1));
  if (btnNext) btnNext.addEventListener('click', () => showImage(current + 1));

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) dialog.close();
  });

  dialog.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') showImage(current - 1);
    if (e.key === 'ArrowRight') showImage(current + 1);
  });
}
